
import { VModel, Component, Vue, Prop } from 'vue-property-decorator'
import draggable from 'vuedraggable'

import TreeItemEdit from '@/components/draggableElements/treeItemEdit.vue'

@Component({
    name: 'NestedDraggable',
    components: { draggable, TreeItemEdit },
})
export default class NestedDraggable extends Vue {
    @VModel({
        default: () => {
            return []
        },
    })
    items!: Array<any>
    @Prop({ default: 'project' }) module!: string
    @Prop({ default: null }) parent!: Record<string, any> | null
    @Prop({ required: true }) updateItem!: Function
    @Prop({ required: true }) postItem!: Function
    @Prop({ default: true }) disabled!: boolean
    @Prop({ default: true }) move!: boolean

    orderChanged($event: any) {
        const payload = {
            ...$event,
            parent: this.parent ? { id: this.parent.id, type: this.parent.type } : null,
        }
        this.$emit('updateOrder', payload)
    }
}
